import {
    apiRequest,
    saudaraDetail,
    saudaraApprove
} from "../../../../../../services/adapters/kepegawaian/saudaraService"

class ApproveRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", saudaraDetail, {
            params: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", saudaraApprove, {
            body: query
        }, true)
    }
}

export default ApproveRepository